export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7407.0055e7b5.jpg";